// extracted by mini-css-extract-plugin
export default {"options":"option-category__options___1ujfI","option":"option-category__option___1hNne"};